














import { Vue, Component } from 'vue-property-decorator'
import { MemberMap } from '@/types/newPersion'
import { memberList } from '@/api/newPersion'
import { customerId } from '@/views/newPension/utils'
import {
  genderList,
  memberList as memberBodyList,
} from '@/views/newPension/utils/default'

import TsTable from '@/components/TsTable/TsTable.vue' // @ is an alias to /src
import FormItem from '@/components/formItem/index.vue'
import DoalogSlot from '@/components/dialog/doalogSlot.vue'
import commonVar from '@/styles/_commonVar.scss'

@Component({
  components: { FormItem, DoalogSlot, TsTable },
})
export default class PersionDialog extends Vue {
  tableData = {
    data: [],
  };

  tableSelectOpt = [
    {
      type: 'add',
      name: '添加到产品',
      icon: 'el-icon-s-promotion',
      color: commonVar.primaryColor
    },
  ];

  tableTitleObj = {
    title: ' ',
    options: {
      dropdown: false,
      arr: [
        {
          type: 'add',
          name: '新增家庭成员',
        },
      ],
    },
  };

  tableHead = [
    {
      type: 'radio',
    },
    {
      type: 'first',
      propName: 'memberName',
      labelName: '称呼',
    },
    {
      propName: 'gender',
      labelName: '性别',
      filterBody: genderList,
    },
    {
      propName: 'age',
      labelName: '年龄',
    },
    {
      propName: 'memberType',
      labelName: '与本人关系',
      filterBody: memberBodyList,
    },
  ];

  created () {
    this.getMemberList()
  }

  private async getMemberList () {
    const res = await memberList({ customerClientId: customerId })
    if (res?.data) {
      this.tableData.data = res.data
    }
  }

  /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
  handleTableBtn (type: string, tableItem: {}) {
    switch (type) {
      case 'add':
        this.$emit('on-click', 'family')
        break

      default:
        console.log(tableItem)
        break
    }
    // this.$router.push('/manage/userManage')
  }

  // 点击表格第一列
  handleTableFirst (row: MemberMap) {
    this.$emit('on-click', 'family', row)
  }

  /**
   * handleSelectInfo 处理选中操作
   * selectArr 选中内容
   * item 点击当当前项
   * idx  item索引
   */
  handleSelectInfo (arr: MemberMap[]) {
    this.$emit('on-click', 'persion', arr[0]);
    (this.$refs.tsTable as unknown as {clearSelect: Function}).clearSelect()
  }

  /**
   * handleFilter 过滤处理filter
   */
  handleFilter (tags: []) {
    console.log('过滤结果：', tags)
  }
}
